import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import LoginSignup from "./pages/LoginSignup";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WebsiteloadPopup from "./components/WebsiteloadPopup";
import Home from "./pages/Home";
import BackToTop from "./components/BackToTop";
import InsuranceGuided from "./components/InsuranceGuided";
import FinancialCalculators from "./components/FinancialCalculators";
import PolicyBenefits from "./components/PolicyBenefits";
import WhyChoosePolicySamjho from "./components/WhyChoosePolicySamjho";
import TrustSection from "./components/TrustSection";
import InsuranceSupport from "./components/InsuranceSupport";
import About from "./pages/About";
import BuyPolicies from "./pages/BuyPolicies";
import PolicyLocker from "./pages/PolicyLocker";
import PartnerDashboard from "./pages/PartnerDashboard";
import ApniPolicyDetailsPage from "./pages/ApniPolicyDetailsPage";
import FreeClaimDetailsPage from "./pages/FreeClaimDetailsPage";
import RegisterWebinarDetailsPage from "./pages/RegisterWebinarDetailsPage";
import LifeInsurance from "./pages/LifeInsurance";
import HealthInsurance from "./pages/HealthInsurance";
import HomeInsurance from "./pages/HomeInsurance";
import TwoWheelerInsurance from "./pages/TwoWheelerInsurance";
import CarInsurance from "./pages/CarInsurance";
import CyberInsurance from "./pages/CyberInsurance";
import ShopkeeperInsurance from "./pages/ShopkeeperInsurance";
import PersonalAccidentalInsurance from "./pages/PersonalAccidentalInsurance";
import CriticalInsurance from "./pages/CriticalInsurance";
import InsuranceWithInvestment from "./pages/InsuranceWithInvestment";
import EMICalculator from "./pages/EMICalculator";
import RPCalculator from "./pages/RPCalculator";
import PPFCalculator from "./pages/PPFCalculator";
import HRACalculator from "./pages/HRACalculator";
import BMICalculator from "./pages/BMICalculator";
import SICalculator from "./pages/SICalculator";
import CICalculator from "./pages/CICalculator";
import HLVCalculator from "./pages/HLVCalculator";
import ForgotPassword from "./pages/ForgotPassword";
import ScrollToTop from "./components/ScrollTop";
import Blog from "./components/Blog";
import Blogs from "./pages/Blogs";
import TollFreeNumber from "./components/TollFreeNumber";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import NotFound from "./pages/NotFound";

const Layout = ({ children }) => {
  const location = useLocation();
  const hideLayout = location.pathname === "/loginsignup" || location.pathname === "/forgotpassword";
  const NAVBAR_CLEARANCE_CLASS = "pt-24";

  return (
    <>
      <ScrollToTop />

      {!hideLayout && <Navbar />}
      {!hideLayout && <WebsiteloadPopup />}

      <div className={!hideLayout ? NAVBAR_CLEARANCE_CLASS : ""}>
        {children}
      </div>

      {!hideLayout && <Footer />}
      {!hideLayout && <TollFreeNumber />}
      {!hideLayout && <BackToTop />}
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/apnipolicysamjho" element={<Home />} />
            <Route path="/freeclaimconsultancy" element={<Home />} />
            <Route path="/registerwebinar" element={<Home />} />
            <Route path="/loginsignup" element={<LoginSignup />} />
            <Route path="/insurance-guided" element={<InsuranceGuided />} />
            <Route path="/calculators" element={<FinancialCalculators />} />
            <Route path="/insurance-benefits" element={<PolicyBenefits />} />
            <Route path="/why-choose-policy-samjho" element={<WhyChoosePolicySamjho />} />
            <Route path="/trust" element={<TrustSection />} />
            <Route path="/insurance-support" element={<InsuranceSupport />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/buy-policies" element={<BuyPolicies />} />
            <Route path="/policy-locker" element={<PolicyLocker />} />
            <Route path="/partnerdashboard" element={<PartnerDashboard />} />
            <Route path="/apnipolicydetailspage" element={<ApniPolicyDetailsPage />} />
            <Route path="/freeclaimdetailspage" element={<FreeClaimDetailsPage />} />
            <Route path="/registerwebinardetailspage" element={<RegisterWebinarDetailsPage />} />
            <Route path="/life-insurance-advice" element={<LifeInsurance />} />
            <Route path="/health-insurance-guidance" element={<HealthInsurance />} />
            <Route path="/home-insurance-explained" element={<HomeInsurance />} />
            <Route path="/two-wheeler-insurance-advice" element={<TwoWheelerInsurance />} />
            <Route path="/car-insurance-consultation" element={<CarInsurance />} />
            <Route path="/cyber-insurance-explained" element={<CyberInsurance />} />
            <Route path="/shopkeeper-insurance-advice" element={<ShopkeeperInsurance />} />
            <Route path="/personal-accidental-insurance-guidance" element={<PersonalAccidentalInsurance />} />
            <Route path="/critical-illness-insurance-consultation" element={<CriticalInsurance />} />
            <Route path="/insurance-with-investment-advice" element={<InsuranceWithInvestment />} />
            <Route path="/emi-calculator" element={<EMICalculator />} />
            <Route path="/rp-calculator" element={<RPCalculator />} />
            <Route path="/ppf-calculator" element={<PPFCalculator />} />
            <Route path="/hra-calculator" element={<HRACalculator />} />
            <Route path="/bmi-calculator" element={<BMICalculator />} />
            <Route path="/si-calculator" element={<SICalculator />} />
            <Route path="/ci-calculator" element={<CICalculator />} />
            <Route path="/hlv-calculator" element={<HLVCalculator />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsconditions" element={<TermsConditions />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blogs/:slug" element={<Blogs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
};

export default App;
